export default "__VITE_ASSET__BED8_3tH__"